import React from 'react'
import { DialogTitle, DialogContent, DialogActions, Box, Typography } from '@mui/material'
import { useIntl } from 'react-intl'
import { ThemeButton } from '../../../../ui/theme-button'
import { StyledDialogContent } from '../../../../ui/dialogs'

export const BudgetRequestCancelDialog = ({ close, handleCancel }) => {
  const { formatMessage } = useIntl()

  return (
    <Box p={4}>
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="center">
          <Typography variant="h4" color="primary">
            {formatMessage({ id: 'pages.budget.view.modalCancel.title' })}
          </Typography>
        </Box>
      </DialogTitle>
      <StyledDialogContent>
        {formatMessage({ id: 'pages.budget.view.modalCancel.text' })}
      </StyledDialogContent>
      <DialogActions>
        <ThemeButton labelM="large" color="secondary" onClick={handleCancel}>
          {formatMessage({ id: 'pages.budget.view.modalCancel.yes' })}
        </ThemeButton>
        <ThemeButton labelM="large" color="default" onClick={close}>
          {formatMessage({ id: 'pages.budget.view.modalCancel.no' })}
        </ThemeButton>
      </DialogActions>
    </Box>
  )
}
